import React, { useEffect, useState } from 'react';
import { CnPicker } from '@/components/cn-picker/picker';
import { renderToBody } from '@/components/cn-picker/render-to-body';
export function prompt(props) {
    return new Promise((resolve) => {
        const Wrapper = () => {
            const [visible, setVisible] = useState(false);
            useEffect(() => {
                setVisible(true);
            }, []);
            return (React.createElement(CnPicker, { ...props, visible: visible, onConfirm: (val, extend) => {
                    props.onConfirm?.(val, extend);
                    resolve(val);
                }, onClose: () => {
                    props.onClose?.();
                    setVisible(false);
                    resolve(null);
                }, afterClose: () => {
                    props.afterClose?.();
                    unmount();
                } }));
        };
        const unmount = renderToBody(React.createElement(Wrapper, null));
    });
}
